export default "__VITE_ASSET__DMn3TLho__"